// City-level location from the visitor's IP address, for when the browser
// gives no position (location blocked, or no fix in time). Same free GeoIP
// providers as the language detector in App.tsx, tried in order; all three are
// in the CSP connect-src.
export type ApproxCoords = { lat: number; lng: number };

const PROVIDERS: Array<{ url: string; read: (j: any) => ApproxCoords | null }> = [
  { url: 'https://ipapi.co/json/', read: j => ({ lat: Number(j.latitude), lng: Number(j.longitude) }) },
  { url: 'https://ipwho.is/', read: j => (j.success === false ? null : { lat: Number(j.latitude), lng: Number(j.longitude) }) },
  { url: 'https://freeipapi.com/api/json', read: j => ({ lat: Number(j.latitude), lng: Number(j.longitude) }) },
];

let cached: ApproxCoords | null = null;

export async function approximateLocationFromIp(timeoutMs = 4000): Promise<ApproxCoords | null> {
  if (cached) return cached;
  for (const { url, read } of PROVIDERS) {
    try {
      const res = await fetch(url, { signal: AbortSignal.timeout(timeoutMs) });
      if (!res.ok) continue;
      const coords = read(await res.json());
      if (coords && Number.isFinite(coords.lat) && Number.isFinite(coords.lng) && (coords.lat !== 0 || coords.lng !== 0)) {
        cached = coords;
        return coords;
      }
    } catch {
      // try the next provider
    }
  }
  return null;
}
